import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonDirective, CardBodyComponent, CardComponent } from '@coreui/angular';
import { IconDirective } from '@coreui/icons-angular';

@Component({
    standalone: true,
    imports: [CardComponent, CardBodyComponent, ButtonDirective, IconDirective],
    templateUrl: './org-not-found.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrgNotFoundComponent {
    constructor(private router: Router) {}

    @HostListener('document:keydown')
    goToMainMenu() {
        this.router.navigate(['/']);
    }
}
